const COOKIE_KEY = 'xfyun_ch_attribution'
const COOKIE_DOMAIN = '.xfyun.cn'
const COOKIE_MAX_AGE_SECONDS = 24 * 60 * 60
const MAX_CHANNEL_ENCODED_LENGTH = 1024

function isValidChannel (value) {
  if (typeof value !== 'string' || value.trim() === '' || /[\r\n]/.test(value)) return false

  try {
    return encodeURIComponent(value).length <= MAX_CHANNEL_ENCODED_LENGTH
  } catch (e) {
    return false
  }
}

function getQueryParam (search, name) {
  const query = (search || '').replace(/^\?/, '').split('&')
  for (let i = 0; i < query.length; i += 1) {
    const pair = query[i].split('=')
    let decodedName
    try {
      decodedName = decodeURIComponent(pair[0] || '')
    } catch (e) {
      decodedName = null
    }

    if (decodedName === name) {
      try {
        return decodeURIComponent((pair.slice(1).join('=') || '').replace(/\+/g, ' '))
      } catch (e) {
        return null
      }
    }
  }
  return null
}

function isXfyunDomain (hostname) {
  return hostname === 'xfyun.cn' || /\.xfyun\.cn$/i.test(hostname)
}

function readCookie () {
  if (typeof document === 'undefined') return null

  try {
    const cookies = document.cookie ? document.cookie.split(';') : []
    for (let i = 0; i < cookies.length; i += 1) {
      const item = cookies[i].trim()
      const separatorIndex = item.indexOf('=')
      const rawName = separatorIndex === -1 ? item : item.slice(0, separatorIndex)
      if (rawName === encodeURIComponent(COOKIE_KEY)) {
        const rawValue = separatorIndex === -1 ? '' : item.slice(separatorIndex + 1)
        try {
          const value = decodeURIComponent(rawValue)
          if (isValidChannel(value)) return value
        } catch (e) {
          // 同名旧 Cookie 可能无效，继续查找其他作用域下的有效值。
        }
      }
    }
  } catch (e) {
    return null
  }
  return null
}

function writeCookie (value) {
  let encodedValue
  try {
    encodedValue = encodeURIComponent(value)
  } catch (e) {
    return null
  }

  const expires = new Date(Date.now() + COOKIE_MAX_AGE_SECONDS * 1000)
  const cookie = [
    `${encodeURIComponent(COOKIE_KEY)}=${encodedValue}`,
    'Path=/',
    `Max-Age=${COOKIE_MAX_AGE_SECONDS}`,
    `Expires=${expires.toUTCString()}`,
    'SameSite=Lax'
  ]

  if (isXfyunDomain(window.location.hostname)) cookie.push(`Domain=${COOKIE_DOMAIN}`)
  if (window.location.protocol === 'https:') cookie.push('Secure')

  try {
    document.cookie = cookie.join('; ')
  } catch (e) {
    return null
  }

  return readCookie()
}

/** 捕获首个有效 ch，并通过独立 Cookie 在 xfyun.cn 的子域间共享。 */
export function captureChAttribution () {
  if (typeof window === 'undefined' || !window.location) return null

  const existing = readCookie()
  if (existing) return existing

  const ch = getQueryParam(window.location.search, 'ch')
  if (!isValidChannel(ch)) return null

  return writeCookie(ch)
}

export { COOKIE_KEY }

// 尽早执行，避免页面逻辑清理地址后丢失 ch 参数。
captureChAttribution()



// WEBPACK FOOTER //
// ./src/js/libs/ch-attribution.js